var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.214,
    height: 33.214,
    viewBox: "0 0 33.214 33.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    d: "M24.564,9.935l-6.211,6.211L12.142,9.935l-1.6,1.6,6.211,6.211-6.211,6.211,1.6,1.6,6.211-6.211,6.211,6.211,1.6-1.6-6.211-6.211,6.211-6.211-1.6-1.6Z",
    transform: "translate(-1.454 -1.433)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6991",
    "data-name": "Path 6991",
    d: "M29.474,5.989a16.607,16.607,0,1,0,0,23.485,16.606,16.606,0,0,0,0-23.485ZM17.732,32.125A14.393,14.393,0,1,1,32.125,17.732,14.409,14.409,0,0,1,17.732,32.125Z",
    transform: "translate(-1.125 -1.125)",
    fill: "#737373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.848176f611610159b330aeb531739155.svg";
export { ForwardRef as ReactComponent };